// extracted by mini-css-extract-plugin
module.exports = {"container":"FindingOverlayCard_container__ShGup","overlayProperty":"FindingOverlayCard_overlayProperty__1FJyp","severity":"FindingOverlayCard_severity__1zgPJ"};